import React, { useEffect, useState } from 'react';
import { MotifIcon, MotifInput, MotifButton } from "@ey-xd/motif-react";
import { deleteIcon, lockIcon, checkPwdIcon, eyeCloseIcon, eyeIcon } from '../../common/MotifIcons';
import { apiQueryToUploadDataRegional } from "../../common/services/apiBaseUrlConfig";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { getImagePath , getFileTypeName } from '../../common/utility/utility';
import logger from "../../common/utils/logger";

const FileTile = ({ file, removeFile, baseURL, setIsLoading, showError, isFileProtected, showErrorMessage, setshowErrorMessage, setIsCorrectPasswords, isCorrectPassword, onPasswordChange, passwordValue, isSkipAndContinueClicked, isContinueClicked, onUnlockFile, allowDelete,searchValue }) => {
  const [openDialog, setOpenDialog] = React.useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleRemoveFile = (event) => {
    event.preventDefault();
    event.stopPropagation();
    removeFile(file.name,true);
  };

  /* istanbul ignore next -- defensive: handler is not wired to any element in this
     component's JSX, so it is unreachable through the rendered UI. */
  const handleUnlockFile = (event) => {
    event.preventDefault();
    event.stopPropagation();
    // onUnlockFile(file.name);
    onUnlockFile(file.path);
  };

    const isSearching = (searchValue || "").trim().length > 0;
const getHighlightedNodes = (text, highlight) => {
      if (!highlight) return <span className="ft-file-name-text">{text}</span>;
      const escaped = highlight.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      const re = new RegExp(escaped, 'ig');
      const nodes = [];
      let lastIndex = 0;
      let m;
      while ((m = re.exec(text)) !== null) {
        const start = m.index;
        const end = re.lastIndex;
        if (start > lastIndex) nodes.push(text.slice(lastIndex, start));
        nodes.push(
          <span key={start} className="search-highlight" style={{ backgroundColor: 'yellow' }}>
            {text.slice(start, end)}
          </span>
        );
        lastIndex = end;
      }
      if (lastIndex < text.length) nodes.push(text.slice(lastIndex));
      return <span className="ft-file-name-text">{nodes}</span>;
    };
  
  const validateFilePassword = async (filesWithPasswords) => {
    const formData = new FormData();
    setIsLoading(true);

    // Append files and their passwords to FormData
    filesWithPasswords.forEach(({ file }) => {
      formData.append("Files", file);
      formData.append("Password", passwordValue); // Assuming the API expects passwords in a separate field
    });

    try {
      const response = await apiQueryToUploadDataRegional.post(`${baseURL}/api/partners/FileValidation`, formData);
      return response.data;
    } catch (error) {
      logger.error("File validation failed:", error);
      return null; // Return null on error
    } finally {
      setIsLoading(false); // Set loading to false in finally block
    }
  };
  const handleFile = async (file) => {

    if (file.name.endsWith(".zip")) {
      onUnlockFile(file.path);
      return; // Exit the function early
    }

    // Create an array with the file and its password
    const filePassword = passwordValue;
    const filesWithPasswords = [{ file, passwordValue }];


    // Call the validateFiles function with the array
    const response = await validateFilePassword(filesWithPasswords);

    // Handle null response (API error case)
    if (!response) {
      return;
    }

    // onUnlockFile(file.name);
    setIsCorrectPasswords((prevPasswords) => ({
      ...prevPasswords,
      [file.path]: response[0]?.isPasswordTrue,
    }));
    if (response[0]?.isPasswordTrue === false) {
      // If the password is incorrect, open the dialog
      setOpenDialog(true);
      setshowErrorMessage((prevPasswords) => ({
        ...prevPasswords,
        [file.path]: true,
      }));

    }

    else {
      // If the password is correct, call onUnlockFile
      onUnlockFile(file.path);
    }

    // Do something with the response
  };
  const extension = file.name.split('.').pop().toLowerCase();
  let iconClass = 'ft-file-icon'
  if (extension.toLowerCase() == 'pbix') {
    iconClass = 'ft-file-icon-pbix'
  }
  return (

    <div className="ft-file-item">
      <div className={iconClass}>
        <img src={getImagePath(file.name)} alt={`${getFileTypeName(file.name)} icon`} />
      </div>
      <div className={`ft-file-details ${isFileProtected ? 'ft-file-protected' : ''}`}>
        <div className="ft-file-name" key={file.name} title={file.name}>
          <div className="ft-file-name-text" >  {getHighlightedNodes(file.name, searchValue)}</div>
           <div className={`ft-file-type ${isFileProtected ? 'ft-file-protected' : ''}`}>
       <span className='spn-file-type-label'>  Type:</span> {getFileTypeName(file.name)} File
        </div>
        </div>
       
         { isSearching && <div className="ft-file-path" title={file.path}>Path : {file.path} File</div>}
       

        {isContinueClicked && isFileProtected && !isSkipAndContinueClicked && (
          <div className="ft-file-password-wrapper">
            <div className="input-container">
              <MotifInput
                placeholder="Enter password"
                className="ft-file-password-input"
                onChange={(e) => onPasswordChange(file.path, e.target.value)}
                value={passwordValue}
                type={isPasswordVisible ? 'text' : 'password'}
                hideClearButton={true}
              />
              {passwordValue && (
                <button className="ft-password-toggle" onClick={togglePasswordVisibility}>
                  <MotifIcon src={isPasswordVisible ? eyeCloseIcon : eyeIcon} />
                </button>
              )}
            </div>
            <div className="tooltip">
            <button className="pt-file-unlock" onClick={() => handleFile(file)}>
              <MotifIcon src={checkPwdIcon} />
            </button>
            <span className="tooltiptext">Verify Password</span>
          </div>
          </div>
        )}
        {isContinueClicked && isFileProtected && !isSkipAndContinueClicked && showErrorMessage[file.path] && ( // Use prop to conditionally render the error message
          <div className="pt-file-error-message">
            Please provide correct password.
          </div>
        )}
      </div>
      <div className="ft-file-actions">
        {isFileProtected && (
          <MotifIcon src={lockIcon} className="ft-file-lock-icon" />
        )}
        {allowDelete && <button className="ft-file-remove" onClick={handleRemoveFile}>
          {/* <MotifIcon src={deleteIcon} /> */}
           <img
                    src={require("../../common/images/trash.svg").default}
                    alt="Delete-icon"
                    style={{ maxWidth:"93%" }}
                     
                  />
        </button>
        }
      </div>
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          <IconButton
            onClick={handleDialogClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
          <div className="heading">Note</div>
        </DialogTitle>
        <DialogContent>
          <span id="alert-dialog-description">
            The password you have entered is incorrect. Please click on Skip & Continue if you still want to upload the file.
          </span>
        </DialogContent>
        <DialogActions>
          <MotifButton onClick={handleDialogClose} color="primary" autoFocus>
            Close
          </MotifButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FileTile;

